import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	externalPersonLabel: {
		id: 'externalPersonLabel',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
});
